<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[500px] max-w-[600px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: false,
      icon: 'trash-01',
      iconTheme: 'danger',
      title: 'Remove payment details',
      subtitle:
        'Are you sure you want to remove <strong>the saved payment details</strong> for this billing schedule? Future automatic billing attempts will fail until a new payment method is added.',
      showDivider: true
    }"
  ></vs-dialog-header>

  <div class="flex flex-col-reverse sm:flex-row sm:justify-end items-center gap-3 pt-6">
    <button vs-button class="w-full sm:w-auto" appearance="outline" [disabled]="submitting" (click)="close()">
      Cancel
    </button>

    <button vs-button class="w-full sm:w-auto" theme="danger" [disabled]="submitting" (click)="confirm()">
      Remove
      <vs-icon *ngIf="submitting" name="refresh-cw-02" class="animate-spin"></vs-icon>
    </button>
  </div>
</vs-dialog>
